import React, { Fragment, useEffect, useState } from 'react';
import "./Forms.css";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import { useConfirmDialog } from '../../../hooks/useConfirmDialog';
import { useDispatch, useSelector } from 'react-redux';
import { getPdfFormList, updatePdfForm } from '../../../api/workflow'; // Import your upload API function here
import { decryptData } from '../../../utils/helper';
import { failed, success } from '../../../utils/Tostify';
import moment from 'moment';
import Loader from '../../../components/Loader/Loader';
import EditForm from './EditForm';
import { handleFileUpload } from '../../../utils/ImageToBase64';

function FormList({ searchValue, direction, ...args }) {
  let token = useSelector(state => state.userReducer.token);
  const [dropdownOpen, setDropdownOpen] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formList, setFormList] = useState([]);
  const [formdata, setFormdata] = useState({});
  const { getConfirmation } = useConfirmDialog();
  const dispatch  = useDispatch();
  const toggleDropdown = (id) => {
    setDropdownOpen(prevState => prevState.includes(id) ? prevState.filter(item => item !== id) : [...prevState, id]);
  };

  const getPdfForms = async (page, limit, searchKey = "") => {
    let res;
    try {
        setIsLoading(true);
        res = await getPdfFormList({dispatch, token, page, limit, searchKey});
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
            setFormList(responseData);
            setIsLoading(false);
        }else{
          setIsLoading(false);
          failed(res?.message);
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
  };

  const handlePagination = (page) => {
    getPdfForms(page, 10);
  };

  const handlePublished = async (e, formId) => {
    const isChecked = e.target.checked;
    e.target.checked = !isChecked;
    const msg = isChecked ? "Activate" : "Deactivate";
    const confirmed = await getConfirmation({
        title: "Attention!",
        entryName: "",
        actionBtnTitle: "Yes",
        message: `Are you sure you want to ${msg}?`
    });
    if (confirmed) {
        let res;
        try {
            const values = {active: isChecked};
            setIsLoading(true);
            res = await updatePdfForm({values, dispatch, token, formId});
            if (res?.status === "SUCCESS") {
                await getPdfForms(formList?.currentPage, 10);
                setIsLoading(false);
                success(res?.message);
            } else {
                setIsLoading(false);
                failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        }
    } else {
        e.target.checked = !isChecked;
    }
  };

  const handleFileChange = async(e, formId) => {
    const file = e.target.files[0];
    let res;
    try {
      let base64pdfForm = "";
          base64pdfForm = await handleFileUpload(file);
          const fileExtension = file?.type?.split("/")[1];
          const pdfForm = {
              base64String: base64pdfForm,
              extension: fileExtension, // Add the file extension to the object
              name: file?.name
          };
          const payload = {
            pdfForm
          };
      setIsLoading(true);
      res = await updatePdfForm({ values : payload, dispatch, token, formId: formId });
      if (res?.status === "SUCCESS") {
        await getPdfForms();
        success(res.message);
        setIsLoading(false);
      }else{
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }

  };

  const handleDelete = async(formName, formId)=>{
    const isActive = formList?.items?.find((obj)=> obj?._id == formId)?.active;
    if(isActive){
      failed("You can't delete an active form");
      return;
    }
    const confirmed = await getConfirmation({
        title: "Attention!",
        entryName: "",
        actionBtnTitle: "Yes",
        message: `Are you sure you want to Delete ${formName}?`
    });
    if (confirmed) {
        let res;
        try {
            const values = {isDeleted: true};
            setIsLoading(true);
            res = await updatePdfForm({values, dispatch, token, formId});
            if (res?.status === "SUCCESS") {
                await getPdfForms();
                setIsLoading(false);
                success(res?.message);
            } else {
                setIsLoading(false);
                failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        }
    }
  };


  useEffect(() => {
    getPdfForms(1, 10);
  }, []);
  useEffect(() => {
    let timerOut = setTimeout(async () => {
      getPdfForms(1, 10, searchValue);
    }, 1000);
    return () => clearTimeout(timerOut);
  }, [searchValue]);

  return (
    <Fragment>
      {isLoading && <Loader />}
      {showModal ? <EditForm refetch={() => getPdfForms(formList?.currentPage, 10)} setShowModal={() => setShowModal(!showModal)} formdata={formdata} /> : null}
      <div className="table_space table_listing_color">
        <div className="forms_block_workflow">
          <div className="table-responsive">
            <table>
              <thead>
                <tr className="header_table">
                  <th>Form Name</th>
                  <th>State</th>
                  <th>Type</th>
                  <th>Created By</th>
                  <th>Date</th>
                  <th>Active</th>
                  <th>Action</th>
                </tr>
              </thead>
              {formList?.items?.length > 0 ? formList?.items.map((form, index) => (
                <tbody key={form?._id}>
                  <tr>
                    <td colSpan={8} className="bg_light"></td>
                  </tr>
                  <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                    <td>{form?.formTitle}</td>
                    <td>{form?.state?.label}</td>
                    <td>{form?.applicationType?.applicationTitle}</td>
                    <td>{form?.createdBy?.name}</td>
                    <td>{moment(form?.createdAt).format("MMM-DD-YYYY")}</td>
                    <td>
                      <div className="toggle">
                        <input
                          type="checkbox"
                          id={`checktoggle-${form._id}`}
                          onChange={(e) => handlePublished(e, form?._id)}
                          checked={form?.active}
                        />
                        <label htmlFor={`checktoggle-${form._id}`}></label>
                      </div>
                    </td>
                    <td>
                      <Dropdown className="dropdown_blk" isOpen={dropdownOpen.includes(form?._id)} toggle={() => toggleDropdown(form?._id)} direction={direction}>
                        <DropdownToggle caret size="xl" className="column_blk">
                          <div className="for_details">
                            <i className="fa fa-ellipsis-v"></i>
                          </div>
                        </DropdownToggle>
                        <DropdownMenu {...args}>
                          <DropdownItem className="drop_block_content" onClick={() => { setShowModal(true); setFormdata({ ...form, readOnly: false }); }}>
                            <div className="add_hosp">Edit</div>
                          </DropdownItem>
                          <DropdownItem className="drop_block_content" onClick={() => { setShowModal(true); setFormdata({ ...form, readOnly: true }); }}>
                            <div className="add_hosp">View Details</div>
                          </DropdownItem>
                          <DropdownItem className="drop_block_content" onClick={() => form?.formFile?.signedUrl ? window.open(form?.formFile?.signedUrl) : null}>
                            <div className="add_hosp">Download</div>
                          </DropdownItem>
                          <DropdownItem className="drop_block_content">
                            <input type="file" onChange={(e)=> handleFileChange(e, form?._id)} style={{ display: 'none' }} id={`file-input-${form._id}`} />
                            <div className="add_hosp" onClick={() => document.getElementById(`file-input-${form._id}`).click()}>Upload</div>
                          </DropdownItem>
                          <DropdownItem className="drop_block_content" onClick={()=> handleDelete(form?.formTitle, form?._id)}>
                            <div className="add_hosp">Delete</div>
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={8} className="bg_light"></td>
                  </tr>
                </tbody>
              )) : <tr><td colSpan={10}><p className="text-center">No Data Found</p></td></tr>}
            </table>
          </div>
          <CustomPagination
            tableData={formList?.items}
            totalPages={formList?.totalPages}
            totalRows={formList?.totalItems}
            rowsPerPage={10}
            page={formList?.currentPage}
            handlePage={handlePagination}
          />
        </div>
      </div>
    </Fragment>
  );
}

export default FormList;
